// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2aWS4W_4h_945L {\n  margin: 0 20px 18px 20px;\n}\n._3r_PwGzSZB28ug {\n  text-align: center;\n}\n._3r_PwGzSZB28ug ._2NtujweYB_yQrC {\n  color: #172b4d;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.008em;\n  line-height: 24px;\n  margin-top: 28px;\n  margin-top: 12px;\n  margin-bottom: 5px;\n}\n._1zqoWY4UC6h3Qn {\n  margin: 15px 0;\n}\n._1zqoWY4UC6h3Qn ._37celvfjR8Sinf {\n  margin-right: 15px;\n}\n._1zqoWY4UC6h3Qn ._1dUl1Y275gmJ7V {\n  display: inline-flex;\n  margin-bottom: 8px;\n}\n._1zqoWY4UC6h3Qn ._3RFe7fNm6rfi1f {\n  color: #172b4d;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  line-height: 16px;\n  margin-top: 16px;\n  margin-top: 8px;\n  margin-bottom: 4px;\n}\n._1zqoWY4UC6h3Qn ._2ml9ZDztiIOzcN {\n  font-size: 12px;\n  line-height: 16px;\n  color: #5E6C84;\n}\n._1t4uIavfc_vH-S {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n._1t4uIavfc_vH-S .jicAbUor2JZObq {\n  margin-top: 8px;\n  color: #5E6C84;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_2aWS4W_4h_945L",
	"header": "_3r_PwGzSZB28ug",
	"promptHeader": "_2NtujweYB_yQrC",
	"content": "_1zqoWY4UC6h3Qn",
	"viewIcon": "_37celvfjR8Sinf",
	"view": "_1dUl1Y275gmJ7V",
	"viewName": "_3RFe7fNm6rfi1f",
	"viewDescription": "_2ml9ZDztiIOzcN",
	"ctaSection": "_1t4uIavfc_vH-S",
	"link": "jicAbUor2JZObq"
};
export default ___CSS_LOADER_EXPORT___;
